import { createTheme } from "office-ui-fabric-react";

export const OdooTheme = createTheme({
  palette: {
    themePrimary: "#714B67",
    themeLight: "#71befd"
  }
});
